//global google
import React from 'react';
import axios from 'axios';
import './Address1.css';
import './Address.css';
import './Complaintitem.css';
import AuthService from '../Services/auth.service';
//import Map from '../Components/Map'
//import MyLocationIcon from '@mui/icons-material/MyLocation';
//import { LoadScript } from "@react-google-maps/api";
//import { GoogleMap, StandaloneSearchBox, Marker } from "@react-google-maps/api";
import CartService from '../Services/cart.service';

import toast, { Toaster } from 'react-hot-toast';
import { Modal,ModalHeader, ModalBody } from "reactstrap";
import Alertsuccess from '../Pop-up/Alertsuccess';
const lib = ["places"];
const key = "AIzaSyBvyXPnf6v2oiFW2CW1HcsLkDIuI5UoYIQ"; // PUT GMAP API KEY HERE
class Address extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            check:'',
           value:false,
           modal3:false,
           homeChk:0,
          workChk:0,
          otherChk:0,
          currentLocation: { lat: 0, lng: 0 },
            markers: [],
            bounds: null
          }
          
          this.MyCountry = 'India'
          this.Tan='0.00'
          this.Long='0.00'
          
          this.label=''
          this.handleInputChange = this.handleInputChange.bind(this);
    }
    


    componentDidMount ()  {


        /*navigator?.geolocation.getCurrentPosition(
            ({ coords: { latitude: lat, longitude: lng } }) => {
              const pos = { lat, lng };
              this.setState({ currentLocation: pos });
            }
          );
           */
        this.setState({ currentLocation: this.props.currentLocation });
        console.log("props") ;
        console.log(this.props.currentLocation) ;

    }
    
    handleSubmit = e => {
       
        let er =''
        const addressData= {
        address_line1:this.FirstAddress ? this.FirstAddress  : er ='Invaild House'  ,
        address_line2:this.SecondAddress ? this.SecondAddress : er ='Invalid Address' ,
        pincode:this.MyPincode ? this.MyPincode : localStorage.getItem('pin'),
        landmark:this.MyLandmark,
        city:this.MyCity ? this.MyCity :  er ='Invaild City',
        latitude:this.Tan, 
        longitude:this.Long ,
        country:this.MyCountry,
        address_label:this.label
        }
        this.setState({check: er})
        const USR_TOKEN = localStorage.getItem("userToken")
          if(USR_TOKEN && er===''){
             //alert(USR_TOKEN)
              const user =  AuthService.getCurrentUser();
              this.setState({profile:user})
              this.setState({value:true})
                axios.post(process.env.REACT_APP_API_URL+'api/method/ecom.api.add_new_address',addressData,{
                headers : {'Authorization' : USR_TOKEN, 'content-type': 'application/json'}
                
                })      
                .then(  
                    res =>{
                        
                        this.setState({value:true})
                        
                        //alert("New Address Is Added")
                        //toast.success("success")
                        this.setState({ modal3: true })

                         //window.location.href ='/my-profile'
                        //console.log(res.data.message.name)
                      
                       

                        if(this.props.path =='cart'){
                            //toast.success("success")
                            this.setState({ modal3: true })

                            CartService.setAddress(res.data.message.name)
                       // window.location.href = this.props.path ? '/'+this.props.path : '/my-profile' ; 
                       }
                       else{
                        //toast.success("success")
                        this.setState({ modal3: true })
                        //window.location.href ='/my-profile'
                        
                       }
                        } 
                )
               /* .catch(
                    err =>{
                        //this.setState({check:''}) 
                        alert("failed")
                    }
                )*/
            
          }
          else{
            //alert("Not Logged in")
        }

        /* if(this.state.value){
            alert("success")
            window.location.href = "/my-account.html";

        } 
        else{
            alert("failed")
        }       */
            
        
      }
      async handleInputChange(e){
         
        const target = e.target;
        this.label = target.name
        if(target.name==='Home'){
            this.setState({homeChk:1})
            this.setState({workChk:0})
            this.setState({otherChk:0})
        }
        if(target.name==='Work'){
            this.setState({homeChk:0})
            this.setState({workChk:1})
            this.setState({otherChk:0})
        }
        if(target.name==='Other'){
            this.setState({homeChk:0})
            this.setState({workChk:0})
            this.setState({otherChk:1})
        }
      }

getData(){
    this.setState({ currentLocation: this.props.currentLocation });
        console.log("props") ;
        console.log(this.props.currentLocation) ;
}

    alertOpen(e){
        e.preventDefault()
        this.setState({ modal3: true });
    
    }
    alertClose(e){
        this.setState(prevState => ({
          modal3: !prevState.modal3
      }));
    }
    alertCancel= () =>  {
  this.setState(prevState => ({
  modal3: !prevState.modal3
  }));
  }


  render() {
     
       
    
    return <div className="container ">
        <h3 className=" ml-2 address-titlt mb-2 mb-4">Add New Address</h3>
        <div className="mb-0">
        <Toaster
  position="bottom-left"
  reverseOrder={false}
/>
  
               {/* 
                <Map google={this.props.google}
                        center={{lat:  this.props.currentLocation.lat, lng: this.props.currentLocation.lng}}
                        height='180px'
                        zoom={15} />
 */}
           
                
              
 {/*<LoadScript googleMapsApiKey={key} libraries={lib}>
        <Map />
      </LoadScript>*/}
        </div>
        {/*<div className="row mt-2">
        <div className="my-address" >
        <h5 className="locate mb-1 ">Your Location</h5> 
        <p className="new-product address pl-1"></p>
        </div>
        
        <button type="button" className="  ml-5  loc-btn">Locate<MyLocationIcon className="ml-2"/></button>
  </div>*/}
        {/* <form onSubmit={this.handleSubmit}> */}
        <div className="row-form center-space  mb-4">
              <h7  className="green-label pl-1  ">House / Flat No </h7><span className="mandatory-area">*</span>
            <input className="form-controls left-space " type="text" placeholder="" id="example-email-input" onChange={e => this.FirstAddress = e.target.value} />
        </div>
        <div className="row-form center-space  mb-4">
             <h7  className="green-label pl-1 "> Address / Block</h7><span className="mandatory-area">*</span>
            <input className="form-controls left-space" type="text" placeholder="" id="example-email-input" onChange={e => this.SecondAddress = e.target.value}/>
        </div>
        <div className="row-form   center-space  ">
            <h7  className="green-label pl-1 "> Pincode</h7><span className="mandatory-area">*</span>
            <input className="form-controls " type="text" placeholder="" id="example-email-input" onChange={e => this.MyPincode = e.target.value} defaultValue={localStorage.getItem('pin')} readOnly />
        </div> 
        <div className="row-form   center-space  ">
            <h7  className="green-label pl-1 ">Landmark</h7>
            <input className="form-controls " type="text" placeholder="" id="example-email-input" onChange={e => this.MyLandmark = e.target.value}/>
        </div>
        <div className="row-form   center-space  ">
            <h7  className="green-label pl-1 ">City</h7><span className="mandatory-area">*</span>
            <input className="form-controls " type="text" placeholder="" id="example-email-input" onChange={e => this.MyCity = e.target.value}/>
        </div>
        <div className="row-form   center-space  d-none ">
        <h7  className="green-label pl-1 ">Country</h7>
            <input className="form-controls " type="text" placeholder="" defaultValue="India" id="example-email-input" onChange={e => this.MyCountry = e.target.value}/>
        </div>
        <div className="row-form   center-space d-none ">
            <h7  className="green-label pl-1 ">Latitude</h7>
            <input className="form-controls " type="text" placeholder="" id="example-email-input" onChange={e => this.Tan = e.target.value}/>
        </div>
        <div className="row-form   center-space  d-none ">
            <h7  className="green-label pl-1 ">Longitude</h7>
            <input className="form-controls " type="text" placeholder="" id="example-email-input" onChange={e => this.Long = e.target.value}/>
        </div>
        <ul className="category-list inline"> 
            <li><div className="custom-control custom-checkbox ml-1">
                <input onChange={this.handleInputChange} type="checkbox" name="Home" checked={this.state.homeChk} className="custom-control-input my-address-chk-box" id="defaultu" />
                    <label className="custom-control-label product-details my-address-chk-box" for="defaultu">Home</label>
            </div></li>
            <li><div className="custom-control custom-checkbox">
                <input onChange={this.handleInputChange} type="checkbox" name="Work" checked={this.state.workChk} className="custom-control-input my-address-chk-box" id="defaultUnchecked-2"/>
                <label className="custom-control-label product-details my-address-chk-box" for="defaultUnchecked-2">Work</label>
            </div></li>
            <li><div className="custom-control custom-checkbox">
                <input onChange={this.handleInputChange} type="checkbox" name="Other" checked={this.state.otherChk} className="custom-control-input my-address-chk-box" id="defaultUnchecked-3"/>
                <label className="custom-control-label product-details my-address-chk-box" for="defaultUnchecked-3">Other</label>
            </div></li>
        </ul>
        {this.state.check ?<p className="mandatory-content pt-3">{this.state.check}</p>:'' }
        <div className="mobi-sub2-btn mb-2 mt-3 com-itm-btn2 mob-nex-btn mob-nex-btn2 text-center">
        <button type="button" className="  btnn btn-hover btn-outline-success tag-btn  mob-can-btn mob-add-bk-btn ml-3 mb-2" onClick={() => this.props.handleCancel('false')}>Back</button>

        <button type="button"   className=" add-to-cart2 btnn tag-btn mb-2  mob-add-sub-btn " onClick={() => this.handleSubmit()}>Submit</button>
        
      </div>
     {/*  </form> */}



     <Modal
                                size="md"
                                isOpen={this.state.modal3} 
                                toggle={() => this.setState({ modal3: false })}
                                show={this.state.modal3}
                                centered
                            >
                            <ModalBody className="alert-success-img">
                                    <Alertsuccess alertcancel={this.alertCancel} alertmessage="New Address Added"/>

                            </ModalBody>
                          
                          </Modal>
    </div>

        }
    }
    
    export default Address;